import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, DEFAULT_LOCALE } from "./translations";

const LangContext = createContext(null);

const STORAGE_KEY = "nivne_locale";

export function LangProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && translations[saved]) return saved;
    } catch (e) {
      // ignore
    }
    return DEFAULT_LOCALE;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, locale);
      document.documentElement.lang = locale;
    } catch (e) {
      // ignore
    }
  }, [locale]);

  const value = useMemo(
    () => ({
      locale,
      setLocale,
      toggle: () => setLocale((l) => (l === "en" ? "pt" : "en")),
      t: translations[locale] || translations[DEFAULT_LOCALE],
    }),
    [locale],
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
